import React, { FC } from 'react';
import styled from '@emotion/styled';
import { getColor, getTextColor } from '../../style';
import { Link, LinkProps } from 'react-router-dom';

const StyledLink = styled(Link)<{ fontcolor?: string }>(
  {
    fontWeight: 600,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textUnderlinePosition: 'under',
    },
  },
  ({ fontcolor }) => {
    return fontcolor === 'red' ? { ...getTextColor().RED } : { color: getColor().BRAND_1 };
  }
);

interface TextLinkProps extends LinkProps {
  color?: string;
  children: React.ReactNode | null;
  linkRef?: React.Ref<HTMLAnchorElement>;
  [key: string]: any;
}

const TextLink: FC<TextLinkProps> = props => {
  const { color, children, linkRef, ...rest } = props;

  return (
    <StyledLink ref={linkRef} fontcolor={color} {...rest}>
      {children}
    </StyledLink>
  );
};

export default TextLink;
